import type { PathObjectInterface } from '@/map-phaser-new/interfaces'

export const ballonTopRightPath: PathObjectInterface = {
  mainPath: { x: 2237, y: 199 },
  spline: [
    2237, 199, 2430, 201, 2608, 196, 2736, 201, 2859, 218, 2997, 263, 3155, 287, 3222, 303, 3266,
    348, 3326, 376, 3382, 405, 3385, 482,
  ],
}
